import { TSetTrackingDataType } from '../../actions/tracking';

export const SET_TRACKING_DATA_TYPE: TSetTrackingDataType = 'tracking/setData';
